/* eslint-disable no-undef */
export default class FirebaseTrackingModule {
  constructor (store, config) {
    this.config = config
    this.store = store
    this.debug = false
    this.eventJson = require('./FirebaseEventStrings.json')
  }

  init () {
    if (!this.config) {
      console.log('Missing Firebase configurations settings.json')
    }

    if (this.config.debug) {
      this.debug = this.config.debug
    }

    // Your web app's Firebase configuration
    var firebaseConfig = {
      apiKey: this.config.apiKey,
      authDomain: this.config.authDomain,
      databaseURL: this.config.databaseURL,
      projectId: this.config.projectId,
      storageBucket: this.config.storageBucket,
      messagingSenderId: this.config.messagingSenderId,
      appId: this.config.appId,
      measurementId: this.config.measurementId
    }

    // Initialize Firebase
    firebase.initializeApp(firebaseConfig)
    firebase.analytics()
  }

  trackEvent (contextKey, actionKey, obj, label, value) {
    var baseData = {'context': this.eventJson[contextKey]}
    if (label !== undefined) {
      var labelData = {'label': label}
      baseData = Object.assign(baseData, labelData)
    }
    if (value !== undefined) {
      var valueData = {'value': value}
      baseData = Object.assign(baseData, valueData)
    }
    var issueData = Object.assign(baseData, this.getIssueData())
    if (obj !== undefined && obj.pageNumber !== undefined) {
      // We have a page object.
      var pageData = this.getPageData(obj)
      pageData = Object.assign(issueData, pageData)
      // Send event for first page
      this.sendEvent(actionKey, pageData)
      return
    } else if (obj !== undefined) {
      // obj is defined and not a page then it must be an article object.
      var articleData = this.getArticleData(obj)
      var articlePageData = this.getPageData(obj.page)
      var articleMergeData = Object.assign(issueData, articlePageData)
      articleMergeData = Object.assign(articleMergeData, articleData)
      // send event for article
      this.sendEvent(actionKey, articleMergeData)
      return
    }
    this.sendEvent(actionKey, issueData)
  }

  sendEvent (actionKey, data) {
    if (this.debug) {
      console.log(this.eventJson[actionKey], data)
    }
    firebase.analytics().logEvent(this.eventJson[actionKey], data)
  }

  getIssueData () {
    return {
      'publication_name': this.store.state.publicationName,
      'issue_name': this.store.state.issueName,
      'issue_internal_name': this.store.state.issueInternalName,
      'issue_internal_id': this.store.state.issueInternalId,
      'issue_pub_date': this.store.state.pubDateDate,
      'issue_zone': this.store.state.zoneCont,
      'issue_edition': this.store.state.editionCont
    }
  }

  getPageData (singlePage) {
    return {
      'page_section_name': singlePage.attributes.SectionName,
      'page_layout_desk': singlePage.attributes.LayoutDeskCont,
      'page_internal_id': singlePage.id,
      'page_number': singlePage.attributes.Page,
      'page_internal_name': singlePage.attributes.Name
    }
  }

  getArticleData (article) {
    var byline = ''
    if (article.attributes.Byline !== undefined) {
      byline = article.attributes.Byline
    }
    var onlineUrl = ''
    if (article.attributes.onlineUrl !== undefined) {
      onlineUrl = article.attributes.OnlineURL
    }
    return {
      'article_internal_id': article.id,
      'article_internal_name': article.attributes.Name,
      'article_headline': article.attributes.Headline,
      'article_byline': byline,
      'article_online_url': onlineUrl
    }
  }
}
/* eslint-enable no-undef */
